// This file must be imported FIRST to expose React, ApexCharts, and PropTypes globally before any other modules load
// This is critical for react-apexcharts IIFE build which expects these to be available globally
import React from 'react'
import ApexCharts from 'apexcharts'
import PropTypes from 'prop-types'

// Expose React, ApexCharts, and PropTypes globally immediately and synchronously
// This must happen before any code splitting or lazy loading occurs
if (typeof window !== 'undefined') {
  // Set React immediately - this is the critical line
  window.React = React
  // Set ApexCharts immediately - required for react-apexcharts IIFE build
  window.ApexCharts = ApexCharts
  // Set PropTypes immediately - required for react-apexcharts IIFE build
  window.PropTypes = PropTypes

  // React Native WebView: intercept <a download> so exports (ApexCharts PNG/SVG/CSV)
  // are routed through the native file-saving bridge instead of failing silently.
  const canPost =
    typeof window.ReactNativeWebView !== 'undefined' &&
    typeof window.ReactNativeWebView.postMessage === 'function'
  if (canPost && typeof document !== 'undefined' && !window.__nativeDownloadInterceptInstalled) {
    window.__nativeDownloadInterceptInstalled = true

    const toDataUrlAndPost = async (href, filename) => {
      try {
        let dataUrl = href

        // Handle blob: URLs by fetching and converting to a data URL
        if (typeof href === 'string' && href.startsWith('blob:')) {
          const res = await fetch(href)
          const blob = await res.blob()
          dataUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsDataURL(blob)
          })
        }

        const payload = { type: 'download', filename, data: dataUrl }
        window.ReactNativeWebView.postMessage(JSON.stringify(payload))
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Native download intercept failed:', err)
      }
    }

    document.addEventListener(
      'click',
      (e) => {
        const el = e?.target
        const a = el?.closest ? el.closest('a') : null
        if (!a) return
        const filename = a.getAttribute('download')
        const href = a.getAttribute('href') || a.href
        if (!filename || !href) return

        // Intercept only actual "download" links (keep normal navigation intact)
        const isData = typeof href === 'string' && href.startsWith('data:')
        const isBlob = typeof href === 'string' && href.startsWith('blob:')
        if (!isData && !isBlob) return

        e.preventDefault()
        e.stopPropagation()
        toDataUrlAndPost(href, filename)
      },
      true
    )
  }
}

export default React

